export default {"src":"/_next/static/media/logout.ef9a0f7f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};